import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Liste nominative d'une classe, réduite à ce qu'un écran d'appel a besoin de
 * montrer : `{ nom, eleves: [{ id, nom, prenom }] }`.
 *
 * `?eleve_fields=nom,prenom` n'est pas un détail de confort : sans lui,
 * `ClasseDetailSerializer.get_eleves` sort aussi `resultats` — tous les
 * résultats d'évaluation de chaque élève — plus le bloc GAR. La projection
 * n'affiche que des noms, et elle recharge la liste après chaque
 * réassignation.
 */
export const useRosterClasse = (classeId, refresh) => {
  const enabled = classeId ? undefined : 'not-enabled';
  return useApi(`${url}classes/${classeId}/?eleve_fields=nom,prenom`, null, refresh, enabled);
};
